import { connect } from 'react-redux';
import ManuCompleteOrderPage from './ManuCompleteOrderPage';
import { Dispatch , AnyAction } from 'redux';
import { AppState } from '../../redux';
import { getManuFactCompletedData, rowClick, downloadURL, onbulkDownload, approvalRequired, onBulkDownloadStl, printClient, 
        onBulkDownloadIndividual, onManuFilterCompletedData, defaultDesignReadyData, rowFbStatusClick } from 'src/actions/completeOrderAction';
import { ManuCompOrderFilterData, RowDataCompleted } from 'src/reducers/completeorderfile';
import { rework } from 'src/actions/liveOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { openVideoPlayerURLArray } from 'src/actions/landingPageAction';
import { SHOW_FAILED_FILES_DIALOG } from '../../reducers/completeorderfile';
// import { push } from 'react-router-redux';
// import {
//     saveFeedbackType,
//     saveCommands,
//     doFeedback
// } from '../../actions/feedbackAction';

export const mapStateToProps = (state: AppState) => {
    return {
        completeOrderData: state.completeOrder.completeOrderData,
        isDownloading: state.completeOrder.isDownloading,
        orderDataTat: state.fileUpload.orderDataTat,
        orderDataManufacturer: state.fileUpload.orderDataManufacturer,
        redesignReasons: state.completeOrder.redesignReasons,
        userInfo: state.user.userDetails,
        redirectDesignReady: state.completeOrder.redirectDesignReady,
        // New properties for failed files dialog
        failedFiles: state.completeOrder.failedFiles,
        showFailedFilesDialog: state.completeOrder.showFailedFilesDialog,
        failedFilesMessage: state.completeOrder.failedFilesMessage,
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getCompleteOrderData);
            // dispatch(getRedesignReasons);
        },
        onComponentWillMount: (data: boolean) => {
            dispatch(doCheckAuthentication);
            if (data) {
                dispatch(onManuFilterCompletedData(defaultDesignReadyData));
            } else {
                dispatch(getManuFactCompletedData);
            }
        },
        reload: () => {
            dispatch(getManuFactCompletedData);
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onRowClickFbStatus: (orderid: string, rowData: string, feedbackreview: string) => {
            dispatch(rowFbStatusClick(orderid, rowData, feedbackreview));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Final Scan'));
        },
        onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onbulkDownload(completedData, true));
        },
        onBulkDownloadIndividual: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onBulkDownloadIndividual(completedData, true));
        },
        printClient: (completedData: RowDataCompleted) => {
            dispatch(printClient(completedData));
        },
        onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => {
            dispatch(onBulkDownloadStl(completedData, filetype, true));
        },
        approvalRequired: (array: Array<object>) => {
            dispatch(approvalRequired(array));
        },
        redesignRequest: (columns: Object) => {
            dispatch(rework(columns, 'completed'));
        },
        dateFilter: () => {
            dispatch(getManuFactCompletedData);
        },
        dateReset: () => {
            dispatch(getManuFactCompletedData);
        },
        openVideoPlayerURL: (fullPath: string[], fpath: string) => {
            dispatch(openVideoPlayerURLArray(fullPath, fpath));
        },
        onFilterChange: (data: ManuCompOrderFilterData) => {
            dispatch(onManuFilterCompletedData(data));
        },
        closeFailedFilesDialog: () => {
            dispatch({ type: SHOW_FAILED_FILES_DIALOG, showFailedFilesDialog: false } as AnyAction);
        },
    };
};
  
const ManuCompleteOrderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ManuCompleteOrderPage);

export default ManuCompleteOrderContainer;



// WEBPACK FOOTER //
// ./src/components/ManuCompleteOrderPage/ManuCompleteOrderPageContainer.tsx